// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1iAvN","empty":"ModalGraph_empty__syfby"};